{
  "meet.answer.empty": "No calls match.",
  "meet.answer.failed": "Could not load the calls.",
  "meet.answer.group.live": "Live now",
  "meet.answer.group.recent": "Recent",
  "meet.answer.group.upcoming": "Upcoming",
  "meet.answer.rooms.title": "Calls",
  "meet.answer.show.all": "All calls",
  "meet.answer.show.recent": "Recent",
  "meet.answer.show.upcoming": "Upcoming",
  "meet.answer.transcript.failed": "Could not load the transcript.",
  "meet.answer.transcript.none": "No call has a transcript yet.",
  "meet.bucket.calendar": "Calendar",
  "meet.bucket.calendarView": "View event",
  "meet.bucket.chat": "Chat",
  "meet.bucket.chatView": "Open chat",
  "meet.bucket.knowledgeBase": "Knowledge base",
  "meet.bucket.knowledgeBaseView": "View article",
  "meet.bucket.notes": "Notes",
  "meet.bucket.notesView": "View note",
  "meet.bucket.tickets": "Tasks",
  "meet.bucket.ticketsView": "View task",
  "meet.captions.listening": "Listening for speech…",
  "meet.chat.close": "Close chat",
  "meet.chat.empty": "No messages yet. Say hello!",
  "meet.chat.heading": "In-call chat",
  "meet.chat.participant": "Participant",
  "meet.chat.send": "Send message",
  "meet.confirm.createArticle": "Create article",
  "meet.confirm.createArticleHint": "Create a new article from this transcript suggestion.",
  "meet.confirm.createEvent": "Create event",
  "meet.confirm.createEventHint": "Create a new event from this transcript suggestion.",
  "meet.confirm.createMessage": "Create message",
  "meet.confirm.createMessageHint": "Create a new message from this transcript suggestion.",
  "meet.confirm.createNote": "Create note",
  "meet.confirm.createNoteHint": "Create a new note from this transcript suggestion.",
  "meet.confirm.createTicket": "Create ticket",
  "meet.confirm.createTicketHint": "Create a new ticket from this transcript suggestion.",
  "meet.confirm.updateArticle": "Update article",
  "meet.confirm.updateArticleHint": "Update the existing article with this transcript suggestion.",
  "meet.confirm.updateEvent": "Update event",
  "meet.confirm.updateEventHint": "Update the existing event with this transcript suggestion.",
  "meet.confirm.updateMessage": "Update message",
  "meet.confirm.updateMessageHint": "Update the existing message with this transcript suggestion.",
  "meet.confirm.updateNote": "Update note",
  "meet.confirm.updateNoteHint": "Update the existing note with this transcript suggestion.",
  "meet.confirm.updateTicket": "Update ticket",
  "meet.confirm.updateTicketHint": "Update the existing ticket with this transcript suggestion.",
  "meet.control.clearSelection": "Clear selection",
  "meet.control.endRoom": "End room",
  "meet.control.endRoomHint": "Mark the room as ended (owner only)",
  "meet.control.hideSidebar": "Hide sidebar",
  "meet.control.layout": "Layout",
  "meet.control.leave": "Leave",
  "meet.control.muteAll": "Mute all",
  "meet.control.muteAllHint": "Mute all non-host participants (owner only)",
  "meet.control.muteCheckedHint": "Mute the checked participants (owner only)",
  "meet.control.muteSelected": "Mute selected ({count})",
  "meet.control.roomSettings": "Room settings",
  "meet.control.selectAll": "Select all",
  "meet.control.selectAllHint": "Select every mutable participant for a batch mute (owner only)",
  "meet.control.shareScreen": "Share screen",
  "meet.control.showSidebar": "Show sidebar",
  "meet.control.tileCount": "Number of tiles shown per screen",
  "meet.control.tiles": "Tiles: {value}",
  "meet.control.toggleCamera": "Toggle camera",
  "meet.control.toggleCaptions": "Toggle captions",
  "meet.control.toggleChat": "Toggle chat",
  "meet.control.toggleMic": "Toggle mic",
  "meet.control.toggleSidebar": "Toggle sidebar",
  "meet.control.toggleTranscript": "Toggle transcript panel",
  "meet.control.viewTranscript": "View full transcript",
  "meet.error.capacityHint": "The call service refused the join (HTTP 429 — its capacity limit is reached). Retry will not clear this. Contact support.",
  "meet.error.capacityTitle": "Calls are unavailable right now.",
  "meet.error.configHint": "The server has no call-service configuration. Retry will not clear this.",
  "meet.error.configTitle": "Call service not configured.",
  "meet.error.forbiddenHint": "The call service refused the credential (HTTP {status}). Retry will not clear this. Contact support.",
  "meet.error.forbiddenTitle": "You can't join this call.",
  "meet.error.missingHint": "The call service does not have this room (HTTP {status}).",
  "meet.error.missingTitle": "This call is no longer available.",
  "meet.error.networkHint": "Couldn't reach the call service. Try Retry. Contact support if it keeps happening.",
  "meet.error.networkTitle": "Connection hiccup — couldn't reach the call server.",
  "meet.error.unknownTitle": "Couldn't join: {message}",
  "meet.fly.aiName": "Symbols AI",
  "meet.fly.backToCall": "Back to call",
  "meet.fly.confirmCancel": "Cancel",
  "meet.fly.confirmHeard": "I heard:",
  "meet.fly.confirmHint": "Say “yes” or “no”",
  "meet.fly.confirmLabel": "Confirm the request",
  "meet.fly.confirmQuote": "“{prompt}”",
  "meet.fly.confirmShow": "Show",
  "meet.fly.mentionLabel": "Agents to ask",
  "meet.fly.modeNoVoice": "Fly is on — this room has no transcript, so ask with @ai in the chat",
  "meet.fly.modeOff": "Fly is on — turn it off",
  "meet.fly.modeOn": "Turn Fly on — anyone in the call can ask Symbols AI for a page: say “Symbols AI, …” or type @ai",
  "meet.fly.pages": "The call's pages ({n})",
  "meet.fly.placeholder": "Message — type @ to ask an agent",
  "meet.guest.admitted": "Admitted — connecting…",
  "meet.guest.back": "Back",
  "meet.guest.callEnded": "This call has ended.",
  "meet.guest.connectionLost": "Connection lost — check your network.",
  "meet.guest.connectionLostHint": "We couldn't reach the server to check your admission status.",
  "meet.guest.declined": "The host declined your request",
  "meet.guest.email": "EMAIL",
  "meet.guest.emailPlaceholder": "jane@example.com",
  "meet.guest.heading": "Join call as guest",
  "meet.guest.joinCall": "Join call",
  "meet.guest.leaveCall": "Leave call",
  "meet.guest.lookupFailed": "Room lookup failed.",
  "meet.guest.missingRoom": "Missing room id — check the share link.",
  "meet.guest.name": "YOUR NAME",
  "meet.guest.namePlaceholder": "e.g. Jane Doe",
  "meet.guest.password": "PASSWORD",
  "meet.guest.passwordPlaceholder": "Room password",
  "meet.guest.requestToJoin": "Request to join",
  "meet.guest.retry": "Retry",
  "meet.guest.roomNotFound": "Room not found or not public.",
  "meet.guest.subtitleAdmit": "Fill in your details. The host will need to admit you.",
  "meet.guest.subtitleAuto": "Fill in your details to join directly.",
  "meet.guest.tryAgain": "Try again",
  "meet.guest.waitHint": "This usually takes a few seconds. Leave this tab open.",
  "meet.guest.waitingForHost": "Waiting for the host to let you in",
  "meet.join.camera": "Camera",
  "meet.join.cameraHint": "Others can see you while it is on",
  "meet.join.cancel": "Cancel",
  "meet.join.heading": "Join call",
  "meet.join.hint": "Choose your devices first. Nothing turns on until you join.",
  "meet.join.joinNow": "Join now",
  "meet.join.mic": "Microphone",
  "meet.join.micHint": "Others can hear you while it is on",
  "meet.layout.grid": "Grid",
  "meet.layout.gridHint": "Everyone equal — pin or share to feature",
  "meet.layout.speaker": "Speaker",
  "meet.layout.speakerHint": "Spotlight whoever's talking",
  "meet.link.copiedGuestTitle": "Guest link copied",
  "meet.link.copiedMessage": "Pasteable URL is in your clipboard.",
  "meet.link.copiedWorkspaceTitle": "Workspace link copied",
  "meet.link.copyGuest": "Copy guest link",
  "meet.link.copyWorkspace": "Copy workspace link",
  "meet.link.manualMessage": "Clipboard access was blocked — copy from the prompt.",
  "meet.link.manualTitle": "Copy this link manually",
  "meet.link.promptLabel": "Copy this link:",
  "meet.main.backToCalls": "Back to calls",
  "meet.main.callCount": "{count} calls",
  "meet.main.callCountOne": "1 call",
  "meet.main.calls": "Calls",
  "meet.main.endRoom": "End room",
  "meet.main.guestWaitingOne": "1 guest waiting",
  "meet.main.guestsWaitingCount": "{count} guests waiting",
  "meet.main.joinCall": "Join call",
  "meet.main.newCall": "New call",
  "meet.main.noCalls": "No calls yet",
  "meet.main.noCallsHint": "Start your first room with \"New call\".",
  "meet.main.oneParticipantLive": "1 participant live",
  "meet.main.participantsLive": "{count} participants live",
  "meet.main.reopen": "Reopen",
  "meet.main.roomEnded": "This room has ended",
  "meet.main.settings": "Settings",
  "meet.main.transcript": "Transcript",
  "meet.main.transcriptionOn": "AI transcription on",
  "meet.main.viewTranscript": "View transcript",
  "meet.newRoom.cancel": "Cancel",
  "meet.newRoom.derivedName": "Call — {date}, {time}",
  "meet.newRoom.heading": "New call",
  "meet.newRoom.hint": "Optionally turn on AI transcription — you get a summary with suggested follow-ups when the call ends.",
  "meet.newRoom.nameAria": "Call name",
  "meet.newRoom.namePlaceholder": "Unnamed call — type to name it",
  "meet.newRoom.start": "Start call",
  "meet.newRoom.transcription": "AI transcription",
  "meet.newRoom.transcriptionHint": "Text only, never raw audio. Set at creation.",
  "meet.newRoom.whoCanJoin": "Who can join",
  "meet.page.guest.title": "Join meet",
  "meet.page.meet.title": "Meet",
  "meet.panel.close": "Close transcript",
  "meet.panel.liveTranscript": "Live transcript",
  "meet.panel.waiting": "Waiting for speech…",
  "meet.panel.waitingHint": "Utterances will appear here as soon as someone starts talking.",
  "meet.recap.added": "{count} added",
  "meet.recap.changes": "Changed during the call",
  "meet.recap.updated": "{count} updated",
  "meet.room.backToCalls": "Back to calls",
  "meet.room.ended": "This room has ended",
  "meet.room.endedHint": "The call has been closed by the host.",
  "meet.room.fallbackName": "Call",
  "meet.room.micBlocked": "Mic is blocked",
  "meet.room.micBlockedHint": "Your audio won't be transcribed. Click the lock icon in your browser address bar and allow microphone, then click Retry.",
  "meet.room.retry": "Retry",
  "meet.room.transcribing": "Transcribing",
  "meet.room.untitled": "Untitled call",
  "meet.room.viewTranscript": "View transcript",
  "meet.roomList.createdByYou": "Created by you",
  "meet.roomList.ended": "Ended",
  "meet.roomList.guestsWaiting": "Guests waiting to join",
  "meet.roomList.kindDm": "Direct call",
  "meet.roomList.live": "Live",
  "meet.roomList.onePerson": "1 person in call",
  "meet.roomList.people": "{count} people in call",
  "meet.roomList.transcribed": "Transcribed",
  "meet.roomList.untitled": "Untitled",
  "meet.roomList.waitingCount": "{count} waiting",
  "meet.settings.addMany": "Add {count} members",
  "meet.settings.addMembers": "ADD MEMBERS",
  "meet.settings.addOne": "Add 1 member",
  "meet.settings.autoAdmit": "Auto-admit",
  "meet.settings.autoAdmitHint": "Skip the waiting room — anyone who fills the form joins immediately. Use for low-sensitivity public calls.",
  "meet.settings.copied": "Copied",
  "meet.settings.copy": "Copy",
  "meet.settings.guestJoin": "GUEST JOIN",
  "meet.settings.guestLink": "GUEST LINK",
  "meet.settings.guestLinkHint": "For people outside your workspace — they fill the join form on /meet-guest.",
  "meet.settings.heading": "Room settings",
  "meet.settings.hint": "Configure who can join, AI transcription, and guest requirements. Changes apply immediately for new joiners.",
  "meet.settings.members": "MEMBERS",
  "meet.settings.name": "NAME",
  "meet.settings.namePlaceholder": "e.g. Weekly product sync",
  "meet.settings.password": "PASSWORD (optional)",
  "meet.settings.passwordHint": "Guests must type this before the waiting-room request is accepted.",
  "meet.settings.passwordPlaceholder": "Leave blank for no password",
  "meet.settings.publicCaption": "Anyone with the guest link can join. Guest requirements (name, email, password) apply.",
  "meet.settings.requireEmail": "Require email",
  "meet.settings.requireEmailHint": "Ask guests to enter an email too. Stored with the waiting-room request.",
  "meet.settings.requireName": "Require name",
  "meet.settings.requireNameHint": "Ask guests to enter a name before they can request to join.",
  "meet.settings.save": "Save",
  "meet.settings.searchPlaceholder": "Search teammates to add…",
  "meet.settings.selectPeople": "Select people to add",
  "meet.settings.transcription": "AI transcription",
  "meet.settings.transcriptionHint": "Records text only — never raw audio. The call ends with a transcript page proposing calendar events, tickets, notes.",
  "meet.settings.unnamed": "Unnamed",
  "meet.settings.whoCanJoin": "WHO CAN JOIN",
  "meet.settings.workspaceCaption": "Any teammate in your workspace can join via the workspace link. No guest link.",
  "meet.settings.workspaceLink": "WORKSPACE LINK",
  "meet.settings.workspaceLinkHint": "Share with teammates — they sign in with their workspace account.",
  "meet.sidebar.archive": "Archive",
  "meet.sidebar.archived": "Archived calls",
  "meet.sidebar.calls": "CALLS",
  "meet.sidebar.callsAria": "Calls",
  "meet.sidebar.done": "Done",
  "meet.sidebar.newCall": "New call",
  "meet.sidebar.unarchive": "Unarchive",
  "meet.state.off": "Off",
  "meet.state.on": "On",
  "meet.suggestion.addToKb": "Add to KB",
  "meet.suggestion.confirm": "Confirm",
  "meet.suggestion.create": "Create",
  "meet.suggestion.createEvent": "Create event",
  "meet.suggestion.createHint": "Create a new item from this transcript suggestion.",
  "meet.suggestion.createNote": "Create note",
  "meet.suggestion.createTicket": "Create ticket",
  "meet.suggestion.created": "Created",
  "meet.suggestion.details": "Details",
  "meet.suggestion.messageLabel": "Message",
  "meet.suggestion.metaTo": "To: {email}",
  "meet.suggestion.reviewHeading": "Review suggestion",
  "meet.suggestion.titleLabel": "Title",
  "meet.suggestion.untitled": "Untitled",
  "meet.suggestion.update": "Update",
  "meet.suggestion.updateHint": "Update the existing item with this transcript suggestion.",
  "meet.suggestion.view": "View",
  "meet.suggestion.willUpdate": "Will update existing",
  "meet.tile.backToGrid": "Back to grid",
  "meet.tile.expand": "Expand",
  "meet.tile.mute": "Mute",
  "meet.tile.muteParticipant": "Mute participant (admin)",
  "meet.tile.next": "Next tiles",
  "meet.tile.previous": "Previous tiles",
  "meet.tile.screen": "Screen",
  "meet.tile.selectForBatchMute": "Select for batch mute",
  "meet.tile.speaking": "Speaking",
  "meet.tile.youName": "{name} (you)",
  "meet.tiles.auto": "Auto",
  "meet.transcript.analyze": "Analyze",
  "meet.transcript.applyToFeatures": "Apply to other features",
  "meet.transcript.empty": "No speech captured yet — the transcript fills in as people talk.",
  "meet.transcript.heading": "Transcript",
  "meet.transcript.noAnalysis": "No analysis yet.",
  "meet.transcript.noteTitle": "{room} — summary",
  "meet.transcript.preparing": "Preparing summary…",
  "meet.transcript.processing": "Transcription still processing — check back in a moment.",
  "meet.transcript.regenerate": "Regenerate",
  "meet.transcript.saveToNotes": "Save to notes",
  "meet.transcript.suggestionCount": "{n} suggestions",
  "meet.transcript.suggestionCountOne": "1 suggestion",
  "meet.transcript.summary": "Summary",
  "meet.transcript.unknownSpeaker": "Unknown",
  "meet.transcript.viewNote": "View note",
  "meet.visibility.private": "Private",
  "meet.visibility.privateCaption": "Only members you add explicitly can join or read the transcript.",
  "meet.visibility.privateHint": "Only members you add explicitly",
  "meet.visibility.public": "Public",
  "meet.visibility.publicCaption": "Anyone with the guest link can join — the name, email and password requirements are in the room settings.",
  "meet.visibility.publicHint": "Anyone with the guest link",
  "meet.visibility.workspace": "Workspace",
  "meet.visibility.workspaceCaption": "Any teammate in your workspace can join via the workspace link.",
  "meet.visibility.workspaceHint": "Any teammate in this workspace",
  "meet.waiting.admit": "Admit",
  "meet.waiting.guest": "Guest",
  "meet.waiting.reject": "Reject",
  "meet.widget.inCall": "In call",
  "meet.widget.leaveCall": "Leave call",
  "meet.widget.micOff": "mic off",
  "meet.widget.micOn": "mic on",
  "meet.widget.participantLine": "{count} in call · {mic}",
  "meet.widget.returnToCall": "Return to call",
  "meet.widget.showPages": "Show the call's pages",
  "meet.widget.toggleMic": "Toggle mic"
}
